import styled from 'styled-components';

export const StyledLogo = styled.figure`
  width: ${props => props.width || '120px'};
  margin: 0;
  padding: 0;
  user-select: none;

  @media screen and (min-width: 768px) {
    width: ${props => props.width || '150px'};
  }
`;

export const StyledLogoImg = styled.img`
  max-width: 100%;
`;
